import React from 'react';
import PropTypes from 'prop-types';
import { ArrowLeft } from 'lucide-react';
import { getConfig } from '@edx/frontend-platform';

/**
 * IGEA: Minimal header.
 *   [← Indietro]        Lesson title (centred)
 *
 * In the embedded-modal context (Nuxt frontend) the header is hidden
 * entirely — the modal already provides its own close button.
 *
 * In the standalone LMS context we keep ONLY the back button on the
 * left + the lesson title centred. The previous design had a second
 * X button on the right that redirected to /dashboard — that
 * duplicated the back-button affordance with a different target
 * (history.back() vs hard-navigate to dashboard) and read as
 * "two ways to leave" instead of "one clear back". We removed it
 * per UI/UX audit.
 */
const IgeaHeader = ({ title }) => {
  const isEmbedded = typeof window !== 'undefined' && window.top !== window.self;
  if (isEmbedded) {
    return null;
  }

  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = `${getConfig().LMS_BASE_URL}/dashboard`;
    }
  };

  return (
    <header className="tw-flex tw-items-center tw-px-6 tw-py-4 tw-bg-white tw-sticky tw-top-0 tw-z-50 tw-border-b tw-border-igea-border">
      <button
        type="button"
        onClick={handleBack}
        className="tw-flex tw-items-center tw-gap-2 tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer"
        style={{ color: '#6B7280', fontSize: '14px', fontWeight: 500 }}
        aria-label="Torna indietro"
      >
        <ArrowLeft size={16} strokeWidth={2} />
        <span>Indietro</span>
      </button>
      <div
        className="tw-flex-1 tw-text-center tw-truncate tw-px-4"
        style={{ fontSize: '14px', fontWeight: 600, color: '#1F2937' }}
        title={title || ''}
      >
        {title || ''}
      </div>
      {/* Right-side spacer to keep the centred title visually centred
          in the header (matches the back button's intrinsic width
          plus its gap). Without it the title drifts right of centre. */}
      <div aria-hidden="true" style={{ width: 76 }} />
    </header>
  );
};

IgeaHeader.propTypes = {
  title: PropTypes.string,
};

IgeaHeader.defaultProps = {
  title: '',
};

export default IgeaHeader;
